export default __webpack_public_path__ + "static/media/first-right-img@2x.2a57fdf7.webp";